import { render, staticRenderFns } from "./Planner.vue?vue&type=template&id=2f2cbb10"
import script from "./Planner.vue?vue&type=script&lang=js"
export * from "./Planner.vue?vue&type=script&lang=js"
import style0 from "./Planner.vue?vue&type=style&index=0&id=2f2cbb10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports